// react
import React from "react";

// components
import Modal from "../../../../components/Modal";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// styles
import css from "./DisplaySftpInfoModal.module.scss";

const DisplaySftpInfoModal = (props) => {
	const { url, handleClose } = props;

	const content = (
		<div className={css.infoContainer}>
			<div className={css.modalDescription}>URL for CSV upload:</div>
			<div>{url}</div>
		</div>
	);

	return <Modal content={content} handleClose={handleClose} size="extralarge" />;
};

DisplaySftpInfoModal.propTypes = {
	url: PropTypes.string.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default DisplaySftpInfoModal;
